/***************************************************************************************************
** sx
***************************************************************************************************/

import getCSSPropertyName from "@utils/helpers/document/getCSSPropertyName";

export default function sx(declarations) {
  return Object.entries(declarations).reduce((obj, [name, value]) => {
    if (value === undefined || value === null || value === "") return obj;

    const propertyName = name.startsWith("__") ? getCSSPropertyName(name.replace(/^__/, "")) : name;
    const propertyValue = Array.isArray(value) ? value.join(", ") : value;

    obj[propertyName] = propertyValue;

    return obj;
  }, {});
}
